/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconNavigationBusinessServices = ({
  size = 16,
  className = '',
  ...props
}) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M12.002 13.334h-1.069l-.616-1.776a.333.333 0 0 0-.315-.224H6.668a.333.333 0 0 0-.317.229l-.583 1.771h-1.1a.333.333 0 1 0 0 .666h7.334a.333.333 0 1 0 0-.666zM13.335 1.999H2.711c-.736 0-1.378.641-1.378 1.378v6.979c0 .172.184.311.356.311h12.669a.31.31 0 0 0 .311-.311V3.377c0-.736-.597-1.378-1.334-1.378zm-.666 5.334a.333.333 0 1 1-.666 0V5.137L8.905 8.235a.333.333 0 0 1-.471 0L6.336 6.137 3.571 8.902a.332.332 0 0 1-.472 0 .333.333 0 0 1 0-.471l3-3c.13-.13.341-.13.471 0l2.098 2.098 2.862-2.862H9.334a.333.333 0 1 1 0-.666h3.334v3.334z"
    />
  </svg>
);

IconNavigationBusinessServices.displayName = 'IconNavigationBusinessServices';

IconNavigationBusinessServices.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconNavigationBusinessServices);
IconNavigationBusinessServices.displayName = 'IconNavigationBusinessServices';
